function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.257 3.743l-1.893 1.893A8.976 8.976 0 0012 3c-4.96 0-9.004 4.047-9 9.007a9 9 0 0015.03 6.673.435.435 0 00.018-.632l-.716-.716a.437.437 0 00-.599-.02 7.09 7.09 0 01-4.733 1.8A7.108 7.108 0 014.887 12 7.109 7.109 0 0112 4.887c1.966 0 3.744.796 5.03 2.083l-1.964 1.964a.435.435 0 00.308.743h5.19A.436.436 0 0021 9.242v-5.19a.435.435 0 00-.743-.309z",
  fill: "#adc6ca",
  fillRule: "evenodd"
});

function SvgLoadinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgLoadinginline;